import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';
import { CookieEvents } from './events';

@Injectable()
export class CookieAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'cookie';

  public getCookieMessage() {
    const request = 'getCookieMessage';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.CookieModel>(url);
  }

  public saveCookieMessageConsent(requestBody: app.models.CookieConsentModel) {
    const request = 'saveCookieMessageConsent';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = requestBody;

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, body, [
      CookieEvents.CookieMessageConsentSaved,
    ]);
  }

  public getCookieMessages() {
    const request = 'getCookieMessages';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.CookieModel[]>>(url);
  }

  public getCookieMessageById(cookieMessageId: string) {
    const request = 'getCookieMessageById';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.CookieModel>>(url, {
      cookieMessageId: cookieMessageId,
    });
  }

  public saveCookieMessage(requestBody: app.models.CookieModel) {
    const request = 'saveCookieMessage';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const data = {
      cookieMessageId: requestBody.cookieMessageId,
      message: requestBody.message,
      required: requestBody.required,
      startDate: requestBody.startDate,
      title: requestBody.title,
    };

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, data, [CookieEvents.CookieMessageSaved]);
  }

  public getFirstAvailableStartDateForNewCookieMessage() {
    const request = 'getFirstAvailableStartDateForNewCookieMessage';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<Date>(url);
  }

  public deleteCookieMessage(cookieMessageId: string) {
    const request = 'deleteCookieMessage';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const data = { cookieMessageId: cookieMessageId };

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, data, [CookieEvents.CookieMessageDeleted]);
  }

  public getCookieMessageConsents(cookieMessageId: string, userNameFilter: string) {
    const request = 'getCookieMessageConsents';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.DynamicResponse<app.models.CookieConsentDetailsModel[]>>(url, {
      cookieMessageId: cookieMessageId,
      userNameFilter: userNameFilter,
    });
  }
}
